<template>
  <MultipleChoicesDropdown
    title="Classify"
    :value="startup.classification"
    :show-clear-all="false"
    :single-choice="true"
    :search-enabled="false"
    :is-btn-group="true"
    :choices="getStartupClassification()"
    @change="onChange($event)"
  />
</template>

<script>
import { mapState } from 'vuex'
import { getStartupClassification } from '@/services/startup-classification'

export default {
  computed: {
    ...mapState({
      startup: (state) => state.startupProfile.startup,
    }),
  },
  methods: {
    onChange(choice) {
      const attr = 'classification'
      const value = choice.value
      this.$store.commit('startupProfile/SET_STARTUP_ATTR', { attr, value })
    },
    getStartupClassification,
  },
}
</script>
